export const SITE_CONFIG = {
  ownerName: "Bianca Rotaru",
  linkedInUrl: "https://www.linkedin.com/in/bianca-rotaru-920ba255",
  contactFormAction: "https://formspree.io/f/mnjjjqov"
};
